const throwError = (message: string) => {
  throw new Error(message);
};

export default throwError;
